import React from 'react';
import Plot from 'react-plotly.js';

/**
 * ConnectedLineChart (Plotly)
 *
 * Generic wrapper around react-plotly.js that takes Plotly props:
 *   - data: Plotly.Data[]
 *   - layout: Partial<Plotly.Layout>
 *   - config: Partial<Plotly.Config>
 * Plus a few convenience props.
 *
 * This component is "connected" in the sense that it can be fed from
 * your app state (Redux, props drilling, etc.). It doesn't hardcode any
 * dataset — the caller provides it.
 */
export default function ConnectedLineChart({
  data = [],
  layout = {},
  config = {},
  style,
  className,
  onRelayout,
  onClick,
}) {
  // Provide sensible defaults while still allowing the caller to override.
  const mergedLayout = {
    autosize: true,
    margin: { l: 50, r: 20, t: 40, b: 40 },
    ...layout,
  };

  const mergedConfig = {
    responsive: true,
    displaylogo: false,
    ...config,
  };

  return (
    <Plot
      data={data}
      layout={mergedLayout}
      config={mergedConfig}
      useResizeHandler
      style={{ width: '100%', height: '100%', ...style }}
      className={className}
      onRelayout={onRelayout}
      onClick={onClick}
    />
  );
}
